// The locales an rdrive dashboard ships. These are the CANONICAL spellings — the exact
// keys a `messages` object (and every colocated `messages/` folder in `packages/*`) is
// indexed by, so `normalizeLocale()` can only ever return a key that resolves.
//
// Region/script subtags keep their BCP 47 casing (`zh-Hans`, `zh-Hant`, `pt-BR`): vue-i18n
// looks messages up by exact string, so lower-casing them here would silently blank three
// locales. Matching is case-INSENSITIVE (see normalizeLocale.js) precisely so a host that
// sends `zh-hant` or `PT-br` still lands on the canonical entry.
//
// The list is the app's eleven real bundles (`apps/project-overview/src/locales/*.json`; `vi`, the
// 11th, since 2026-10-28). It is deliberately NOT derived from a messages object: it is the
// contract a dashboard promises to support, and it must be knowable before any bundle is loaded
// (the store normalises the URL param at boot, long before a lazy bundle could arrive).
export const SUPPORTED_LOCALES = [
  'en',
  'fr',
  'it',
  'zh-Hans',
  'zh-Hant',
  'nl',
  'pt-BR',
  'th',
  'de',
  'pl',
  'vi',
];

// The one locale every bundle is guaranteed to have, and therefore the only sane
// `fallbackLocale` for `createI18n` — see packages/rdrive-i18n/README.md "App-side contract".
export const DEFAULT_LOCALE = 'en';
